<li 
    class="nav-menu-item" 
    (click)="clickHandle()" 
    #list
    [class.is-disabled]="navItemDisabled">
    <ng-content></ng-content>
</li>

<!-- [class.is-active]="rootMenu.model === index" -->